export const classes = {
  tab: 'p-4 h-full flex flex-col gap-4',
  button: 'place-start gap-4 px-4',
};
